<template>
  <el-dialog title="关联达人" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
      <el-form-item label="关联达人" prop="anchor_id">
        <dr-select v-model="form.anchor_id" placehoder="请选择 / 搜索关联达人"></dr-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { talentContact } from '@/api/talentCRM'
import DrSelect from '@/components/drSelect';
export default {
  name: 'addContactDialog',
  components: {
    DrSelect
  },
  data () {
    return {
      dialogVisible: false,
      id: '',
      form: {
        anchor_id: ''
      },
      rules: {
        anchor_id: { required: true, message: '请选择关联达人', trigger: 'change' }
      },
    }
  },
  methods: {
    show(id) {
      this.id = id
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.form = {
        anchor_id: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        const { id, form: { anchor_id } } = this
        const { code } = await talentContact({
          id,
          anchor_id,
          is_pass: 1,
          contact_type: 1,
          operate_time: Math.trunc(Date.now() / 1000)
        })
        if(code !== 0) return
        this.$message.success('关联成功')
        this.handleClose()
        this.$emit('getList')
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
